import client from '@/api/client';
import { gql } from '@apollo/client';
import fragments from '@/gql-fragments/student-lists';
import imagesFragments from '@/gql-fragments/images';
import userFragments from '@/gql-fragments/user';
import teacherFragments from '@/gql-fragments/teacher';

import { ReferralData } from '@/interfaces/dashboard/student-dashboard';

const getStudentInfo = () => client
  .query({
    query: gql`
      query {
        getStudentInfo {
          englishLevel {
            title
          }
          id
          name
          phone
          skype
          balance
          country
          languageCommunication
          status
          user {
            ...User
            avatar {
              ...Avatar
            }
          }
        }
      }
      ${imagesFragments.Avatar}
      ${userFragments.User}
    `,
  });

const getTeacherInfoForStudent = (id: number) => client
  .query({
    query: gql`
    query ($id: Int) {
      getTeachers(id: $id) {
        ...TeacherForStudent,
      }
    }
    ${teacherFragments.TeacherForStudent}
  `,
    variables: {
      id: +id,
    },
  });

const getStudentCard = (listId: number) => client
  .query({
    query: gql`
      query(
        $listId: Int
      ) {
        getStudentCard(listId: $listId) {
          ...List
          session {
            ...Session
            student {
              ...Student
            }
            course {
              ...Course
            }
          }
        }
      }
      ${fragments.Course}
      ${fragments.List}
      ${fragments.Session}
      ${fragments.Student}
    `,
    variables: {
      listId,
    },
  });

const getStudentStatisticsBySession = (sessionId: number) => client
  .query({
    query: gql`
      query(
          $sessionId: Int
      ) {
        getStudentStatisticsBySession(sessionId: $sessionId) {
          homeworkPercentage
        }
      }
  `,
    variables: {
      sessionId,
    },
  });

const registerStudent = (data: {
  teacherId: number;
  studentId: number;
  courseId: number;
  force: number;
}) => client
  .mutate({
    mutation: gql`
      mutation(
        $teacherId: Int,
        $studentId: Int,
        $courseId: Int,
        $force: Int,
      ) {
        addStudentByInvite(
          teacherId: $teacherId,
          studentId: $studentId,
          courseId: $courseId
          force: $force,
        ) {
          status
        }
      }
    `,
    variables: {
      ...data,
    },
  });

const registerStudentSelf = (data: {
  studentId: number;
  courseId: number;
}) => client
  .mutate({
    mutation: gql`
      mutation(
        $studentId: Int,
        $courseId: Int
      ) {
        studentRegistrationSelf(
          studentId: $studentId,
          courseId: $courseId
        ) {
          status
        }
      }
    `,
    variables: {
      ...data,
    },
  });

const studentBalanceUpdate = (data: {
  studentId: number;
  balance: number;
}) => client
  .mutate({
    mutation: gql`
      mutation(
          $studentId: Int,
          $balance: Int,
      ) {
        studentBalanceUpdate(
            studentId: $studentId,
            balance: $balance
        ) {
            ...Student
        }
      }
      ${fragments.Student}
  `,
    variables: {
      ...data,
    },
  });

const postReferrals = (data: ReferralData) => client
  .mutate({
    mutation: gql`
    mutation postReferrals($inviteName: String, $inviteEmail: String, $invitePhone: String) {
      postReferrals(inviteName: $inviteName, inviteEmail: $inviteEmail invitePhone: $invitePhone) {
        status
      }
    }
  `,
    variables: {
      ...data,
    },
  });

export default {
  getStudentInfo,
  getStudentCard,
  getStudentStatisticsBySession,
  postReferrals,
  registerStudent,
  registerStudentSelf,
  studentBalanceUpdate,
  getTeacherInfoForStudent,
};
